var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgManagement(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Property 1=Navigation, Property 2=Event Modules"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Combined Shape",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.5 1.6001C20.6046 1.6001 21.5 2.49553 21.5 3.6001V9.1501C21.5 10.2547 20.6046 11.1501 19.5 11.1501H5.9V16.5751H7.6V14.8501C7.6 13.7455 8.49543 12.8501 9.6 12.8501H19.5C20.6046 12.8501 21.5 13.7455 21.5 14.8501V20.4001C21.5 21.5047 20.6046 22.4001 19.5 22.4001H9.6C8.49543 22.4001 7.6 21.5047 7.6 20.4001V18.2751L5.05 18.2751C4.58056 18.2751 4.2 17.8945 4.2 17.4251V11.1277C3.23775 10.983 2.5 10.1527 2.5 9.1501V3.6001C2.5 2.49553 3.39543 1.6001 4.5 1.6001H19.5ZM5.04909 9.4501L5.05 9.4501L5.05091 9.4501H19.5C19.642 9.4501 19.761 9.35142 19.7921 9.21889L19.8 9.1501V3.6001C19.8 3.45808 19.7013 3.33911 19.5688 3.30802L19.5 3.3001H4.5C4.35798 3.3001 4.23902 3.39878 4.20792 3.53131L4.2 3.6001V9.1501C4.2 9.29211 4.29868 9.41108 4.43121 9.44217L4.5 9.4501H5.04909ZM9.6 14.5501H19.5L19.5688 14.558C19.7013 14.5891 19.8 14.7081 19.8 14.8501V20.4001L19.7921 20.4689C19.761 20.6014 19.642 20.7001 19.5 20.7001H9.6L9.53121 20.6922C9.39868 20.6611 9.3 20.5421 9.3 20.4001V14.8501L9.30792 14.7813C9.33902 14.6488 9.45798 14.5501 9.6 14.5501Z",
    fill: "#006CB7"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgManagement);
export default __webpack_public_path__ + "static/media/management.de15f8f3babdaa7d819463ae2a23f5dd.svg";
export { ForwardRef as ReactComponent };